/* Shared accordion behaviour. Drives both ss-quick-faq and ss-faq-accordion,
   so both sections load this one file. */

(function () {
  'use strict';

  var ROOT = '[data-ss-accordion]';

  function initSection(root) {
    if (root.dataset.ssAccInit === 'true') return;
    root.dataset.ssAccInit = 'true';

    var single = root.getAttribute('data-accordion-single') === 'true';
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.ss-acc__trigger'));

    function setOpen(trigger, open) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', String(open));
      if (!panel) return;
      if (open) panel.setAttribute('data-open', '');
      else panel.removeAttribute('data-open');
    }

    triggers.forEach(function (trigger, i) {
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';

        // Only one panel open at a time when the section asks for it.
        if (single && !open) {
          triggers.forEach(function (other) {
            if (other !== trigger) setOpen(other, false);
          });
        }
        setOpen(trigger, !open);
      });

      trigger.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowDown') dir = 1;
        else if (e.key === 'ArrowUp') dir = -1;
        else if (e.key === 'Home') dir = -Infinity;
        else if (e.key === 'End') dir = Infinity;
        else return;

        e.preventDefault();
        var idx;
        if (dir === -Infinity) idx = 0;
        else if (dir === Infinity) idx = triggers.length - 1;
        else idx = (i + dir + triggers.length) % triggers.length;
        triggers[idx].focus();
      });
    });

    // Honour whatever the server rendered as open.
    triggers.forEach(function (trigger) {
      setOpen(trigger, trigger.getAttribute('aria-expanded') === 'true');
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
